export default "__VITE_ASSET__aea1dbf5__"